<template>
  <div class="">
    <div>
      <page-header header="User Settings" subheader="Set up your user ID, Contact details"/>
      <panel class="mt-5 pt-6">
        <div class="w-full max-w-full overflow-x-auto overflow-y-hidden border-bottom mb-2">
          <div class="flex justify-between">
            <div class="">
              <nav class="flex flex-col sm:flex-row">
                <li v-if="system.external_data.bios === true" class="py-4 mr-10 block uppercase cursor-pointer" :class="activeTab=='1'?'active border-primary':''" @click="changeValue('1')">
                  Personal, Social and Bio
                </li>
                <li v-else class="py-4 mr-10 block uppercase cursor-pointer" :class="activeTab=='1'?'active border-primary':''" @click="changeValue('1')">
                  Personal
                </li>
                <li class="py-4 mr-10 block uppercase cursor-pointer" :class="activeTab=='2'?'active border-primary':''" @click="changeValue('2')">
                  Account &amp; Password
                </li>
                <li class="py-4 mr-10 block uppercase cursor-pointer" v-if="profile_v2.type <=4" :class="activeTab=='3'?'active border-primary':''" @click="changeValue('3')">
                  Staff
                </li>
                <li class="py-4 mr-10 block uppercase cursor-pointer" v-if="profile_v2.type <=4 && system.external_data.bios === true" :class="activeTab=='4'?'active border-primary':''" @click="changeValue('4')">
                  Meet the Team Pages
                </li>
              </nav>
            </div>
            <div class="flex justify-end">
              <div class="flex" v-if="savingUser">
              <span class="py-4 pl-2 block">saving</span>
              <loader class="py-4 pl-10 block">saving</loader>
              </div>
              <div v-else>
                <div class="py-4 pl-10 block uppercase font-bold">Access Level: {{profile_v2.admin_access}}</div>
              </div>

            </div>

          </div>

        </div>

        <div>
          <div v-show="activeTab=='1'">
            <profile-account @leaving="leaveModal = true" ref="profileAccount" @destination="setDestination" @savingUser="savingUser = $event" :network="network"></profile-account>
          </div>
          <div v-show="activeTab=='2'">
            <profile-password :errorBag="errorBag"></profile-password>
          </div>
          <div v-show="activeTab=='3'">
            <profile-staff ref="profileStaff" @editFromProfile="changeValue('1')" :network="network"></profile-staff>
          </div>
          <div v-show="activeTab=='4'">
            <profile-team></profile-team>
          </div>
        </div>
      </panel>
    </div>
    <modal
      v-if="leaveModal"
      :scrollY="false"
      @dismissed="leaveModal = false"
      @leave="leaveModal = false"
      :showCloseBtn="true"
    >
      <div class="flex h-full flex-col items-center justify-center">
        <div class="p-2 mb-4">
          <p class="text-center">Are you sure you wish to leave before saving your changes?</p>
        </div>
        <div class="flex items-center">
          <button  @click="$refs.profileAccount.buttonPress = true, $router.push({path: destination.path})" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Yes, leave.
          </button>
          <button @click="leaveModal = false" class="bg-white border border-tertiary text-tertiary rounded px-4 py-3 text-sm font-medium align-bottom m-2">
            No, go back.
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Offices from '@/components/Offices'
import UserAdmin from '@/components/UserAdmin/UserAdmin'
import SocialAccounts from '@/components/SocialAccounts'
import ErrorBag from '@/ErrorBag'
import Loader from '@/components/Loader'
import ProfileAccount from '@/components/Profiles/ProfileAccount'
import ProfileBiography from '@/components/Profiles/ProfileBiography'
import ProfilePassword from '@/components/Profiles/ProfilePassword'
import ProfileTeam from '@/components/Profiles/ProfileTeam'
import ProfileStaff from '../components/Profiles/ProfileStaff'
import {
  GUILD_NETWORK_ID,
  FC_NETWORK_ID,
  FC_INTL_NETWORK_ID
} from '@/consts'

export default {
  components: {
    Offices,
    UserAdmin,
    SocialAccounts,
    Loader,
    ProfileAccount,
    ProfileBiography,
    ProfilePassword,
    ProfileTeam,
    ProfileStaff
  },
  beforeRouteLeave (to, from, next) {
    this.$refs.profileAccount.prepareToExit(to, from, next)
  },
  data () {
    return {
      errorBag: new ErrorBag(),
      savingProfile: false,
      deletePhotoLoader: false,
      activeTab: '1',
      profile: {},
      savingUser: false,
      leaveModal: false,
      destination: null,
      network: null,
      GUILD_NETWORK_ID,
      FC_NETWORK_ID,
      FC_INTL_NETWORK_ID,
      fc_network_array: [
        FC_NETWORK_ID,
        FC_INTL_NETWORK_ID
      ]
    }
  },

  computed: {
    ...mapState([
      'profile_v2', 'userOfficeList', 'selectedOffice', 'system'
    ]),
    offices () {
      // return this.userOfficeList
      return [this.selectedOffice]
    },
    password () {
      return this.profile.password
    }
  },

  watch: {
    password (newPassword) {
      if (!newPassword) {
        delete this.profile.password
        delete this.profile.password_confirmation
        this.errorBag.delete('password')
      }
    }
  },

  created () {
    this.network = this.getNetwork()
    this.fetchProfile()
    this.fetchProfileV2()
  },

  methods: {
    ...mapActions([
      'fetchProfile',
      'updateProfile',
      'updateProfilePic',
      'notifyAdmin',
      'displayToastNotification',
      'deleteProfilePic',
      'fetchProfileV2'
    ]),
    getNetwork () {
      if (this.fc_network_array.indexOf(this.system.networks[0].id) !== -1) {
        return 'fc'
      }
      if (this.system.networks[0].id === GUILD_NETWORK_ID) {
        return 'guild'
      }
      return 'other'
    },
    setDestination (val) {
      this.destination = val
    },
    saveProfile () {
      this.savingProfile = true
      this.updateProfile(this.profile)
        .then(response => {
          this.errorBag.clear()
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Profile Updated',
            info: 'Your profile has been updated successfully.'
          })
        })
        .catch(error => this.errorBag.store(error.response.data))
        .finally(() => { this.savingProfile = false })
    },
    changeValue (id) {
      this.activeTab = id
    }
  }
}
</script>

<style lang="scss" scoped>
  .active {
    @apply border-b-4;
    @apply font-medium;
  }
</style>
